var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChatIcon = function SvgChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 .5A17.5 17.5 0 0 0 3 26.9l-1 6.8a1.6 1.6 0 0 0 2 1.7l6.5-1.6a17.3 17.3 0 0 0 7.5 1.7 17.5 17.5 0 1 0 0-35z",
    fill: "#003E52",
    fillRule: "evenodd"
  })));
};
export default SvgChatIcon;